import React, { useMemo } from 'react';

import { Stack } from '@mui/material';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid-pro';
import { useQuery } from '@tanstack/react-query';

import { FormFilterCentroDistribuicao } from '..';

import { EditRemoveBtn } from 'components/buttons';
import { PanelGrid } from 'components/grid';
import { Block, OneColumn } from 'components/page';
import { useListagemContext } from 'context/ListagemContext';
import { RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';

const generateCentroDistribuicaoList = (data: any[] | undefined): GridRowsProp => {
    const list = data;

    if (Array.isArray(list) && list.length) {
        return list.map((item, index) => ({
            id: index + 1,
            idCentroDistribuicao: item.idCentroDistribuicao,
            dsCentroDistribuicao: item.dsCentroDistribuicao,
            cdCentroDistribuicao: item.cdCentroDistribuicao,
        }));
    }
    return [];
};

export function CentroDistribuicaoListComp() {
    const { filter, page, sort, limit } = useListagemContext();
    const RequestListagem = useRequestListagem();

    const requestOptions: RequestOptionsType = {
        url: '/gestao/centrodistribuicao',
        sort: sort && sort.length > 0 ? sort : [{ property: 'idCentroDistribuicao', direction: 'DESC' }],
        columns: 'idCentroDistribuicao,dsCentroDistribuicao,cdCentroDistribuicao,fgAtivo',
        nested: true,
        filter: [...filter, { property: 'fgAtivo', value: true, operator: 'eq' }],
        page,
        limit,
    };

    const { fetchStatus, data, refetch } = useQuery([requestOptions], () => {
        const request: Promise<any> = RequestListagem(requestOptions).then((res: any) => res.data);
        return request;
    });

    const columns: GridColDef[] = useMemo(
        () => [
            { field: 'idCentroDistribuicao', headerName: 'Código', alignItems: 'center', flex: 1, type: 'string' },
            { field: 'dsCentroDistribuicao', headerName: 'Descrição', alignItems: 'center', flex: 1, type: 'string' },
            { field: 'cdCentroDistribuicao', headerName: 'Código de Integração', alignItems: 'center', flex: 1, type: 'string' },
            {
                field: 'acoes',
                align: 'center',
                headerAlign: 'center',
                headerName: 'Ações',
                filterable: false,
                sortable: false,
                hideable: false,
                disableColumnMenu: true,
                width: 110,
                renderCell: ({ row }) => (
                    <EditRemoveBtn
                        id={row.idCentroDistribuicao}
                        showEditBtn={true}
                        showRemoveBtn={true}
                        removeUrl={`gestao/centrodistribuicao/${row.idCentroDistribuicao}`}
                        refresh={refetch}
                        sx={{ ml: 'auto', p: 1.5 }}
                    />
                ),
            },
        ],
        [refetch],
    );

    const rows = generateCentroDistribuicaoList(data?.data);

    return (
        <OneColumn title="Centros de Distribuição" createButton>
            <FormFilterCentroDistribuicao />

            <Block>
                <PanelGrid rows={rows} rowsCount={data?.total ?? 0} reload={refetch} loading={fetchStatus === 'fetching'} columns={columns} />
            </Block>
        </OneColumn>
    );
}
